import React, { useEffect, useState, useContext } from 'react';
import {
    Grid,
    makeStyles,
    TextField,
    Select,
    FormControl,
    InputLabel,
    CircularProgress,
    FormHelperText,
} from '@material-ui/core';

import { Field } from 'formik';

import InputMask from 'react-input-mask';

import { useSelector, useDispatch } from 'react-redux';
import { fetchServiceDocuments } from 'app/store/slices/services';
import helpers from 'app/utils/helpers';
import { fecthAllPersonTypes } from 'app/store/slices/company';
import { FormServiceContext } from 'app/utils/contexts';

import { SERVICES_CODES } from 'app/config/services';
import RegistrationStatus from '../../../components/RegistrationStatus';
import { confirmaAlteracaoTipoComplementar } from '../../../Company/components/MainData/MainData';

import { KeyboardDatePicker } from '@material-ui/pickers';

import styles from './styles';
import companyEndpoints from '../../../../../../api/services/companyEndpoints';
const useStyles = makeStyles(styles);

function MainData(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const documentMask = '999.999.999-99';

    const activeCompany = useSelector((state) => state.company.activeCompany);
    const personTypes = useSelector((state) => state.company.personTypes);
    const service = useSelector((state) => state.services.details);
    const request = useSelector((state) => state.requests.details);

    const [loadingPersonTypes, setLoadingPersonTypes] = useState(true);
    const [blockDoc] = useState(true);
    const [company, setCompany] = useState({});

    const { errors, values, onChangeDate } = props;

    const { setLoadingDocuments, canEdit } = useContext(FormServiceContext);

    useEffect(() => {
        if (Object.keys(company).length > 0) return;
        if (Object.keys(activeCompany).length > 0) {
            setCompany(activeCompany);
            return;
        }
        const cdEmpresa = request?.cdEmpresa ?? props.initialValues?.cdEmpresa;
        if (cdEmpresa === undefined) return;
        companyEndpoints.getCompany({ cdEmpresa }).then((response) => {
            if (response && response.status === 200) setCompany(response.data);
        });
        // eslint-disable-next-line
    }, [activeCompany, request, props.initialValues]);

    const onBlurNomeCompleto = ({ target: { value } }, values) => {
        values.flAlteradoNomeCompleto = value !== company.nmCompleto;
    };

    const onChangePersonType = async (e, values) => {
        const value = Number(e.target.value);

        if (values && value) {
            if (Number(values.cdTipoPessoaFisica) !== value) {
                if (!(await confirmaAlteracaoTipoComplementar(company, value, values, personTypes))) {
                    return;
                }
                values.cdTipoPessoaFisica = value;
                setLoadingDocuments(true);
                try {
                    await dispatch(
                        fetchServiceDocuments({
                            cdServico: service.cdServico,
                            cdTipoPessoaFisica: value,
                        }),
                    );
                } catch (error) {}
                setLoadingDocuments(false);
            }
        }
    };

    useEffect(() => {
        const init = async () => {
            if (personTypes.length === 0) {
                await dispatch(fecthAllPersonTypes());
            }
            setLoadingPersonTypes(false);
        };
        init();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const validateDocument = (value) => {
        let error;
        if (!helpers.validateCpfCnpj(value)) {
            error = 'Documento inválido';
        }
        return error;
    };

    return (
        <Grid container spacing={3} className={classes.containerMainData}>
            <RegistrationStatus {...props} classes={classes} />

            <Grid item xs={12} sm={8}>
                {loadingPersonTypes && <CircularProgress size={20} className={classes.loading} />}
                {!loadingPersonTypes && (
                    <FormControl variant="filled" margin="dense" fullWidth error={!!errors.cdTipoPessoaFisica}>
                        <InputLabel htmlFor="cdTipoPessoaFisica" shrink={true}>
                            Tipo de pessoa*
                        </InputLabel>
                        <Field
                            name="cdTipoPessoaFisica"
                            id="cdTipoPessoaFisica"
                            native
                            disabled={!canEdit}
                            as={Select}
                            onChange={(e) => onChangePersonType(e, values)}>
                            <option aria-label="None" value="">
                                Selecione
                            </option>
                            {personTypes.map((type, index) => {
                                return (
                                    <option key={`type-${index}`} value={type.cdTipoPessoaFisica}>
                                        {type.deTipoPessoaFisica}
                                    </option>
                                );
                            })}
                        </Field>
                        {errors.cdTipoPessoaFisica ? (
                            <FormHelperText>{errors.cdTipoPessoaFisica}</FormHelperText>
                        ) : null}
                    </FormControl>
                )}
            </Grid>
            <Grid item xs={12} sm={4}>
                {!blockDoc && canEdit && service.cdServico !== SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC ? (
                    <Field name="deCpf" validate={validateDocument}>
                        {({ field, form: { errors, values } }) => (
                            <InputMask mask={documentMask} {...field} value={values.deCpf}>
                                {(props) => (
                                    <TextField
                                        {...props}
                                        name="deCpf"
                                        label="CPF*"
                                        variant="filled"
                                        margin="dense"
                                        fullWidth
                                        error={!!errors.deCpf}
                                        helperText={errors.deCpf ? errors.deCpf : ''}
                                    />
                                )}
                            </InputMask>
                        )}
                    </Field>
                ) : (
                    <TextField label="CPF*" value={values.deCpf} variant="filled" margin="dense" disabled fullWidth />
                )}
            </Grid>

            <Grid item xs={12} sm={4}>
                <Field
                    name="nmCompleto"
                    label="Nome completo*"
                    variant="filled"
                    margin="dense"
                    disabled={
                        !canEdit ||
                        service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC ||
                        service.cdServico === SERVICES_CODES.INATIVACAO_CADASTRAL
                    }
                    fullWidth
                    error={!!errors.nmCompleto}
                    helperText={errors.nmCompleto ? errors.nmCompleto : ''}
                    as={TextField}
                    onBlur={(e) => onBlurNomeCompleto(e, values)}
                    inputProps={{
                        maxLength: 130,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Field
                    name="dtNascimento"
                    label="Data de nascimento*"
                    format="DD/MM/YYYY"
                    autoOk
                    clearable
                    clearLabel={'Limpar'}
                    emptyLabel={''}
                    value={helpers.formatarData(values.dtNascimento)}
                    invalidLabel="Data inválida"
                    invalidDateMessage="Data inválida"
                    maxDateMessage="Data inválida"
                    minDateMessage="Data inválida"
                    margin="dense"
                    disabled={!canEdit}
                    onChange={(v) => onChangeDate(values, 'dtNascimento', v)}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    inputVariant="filled"
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                    error={!!errors.dtNascimento}
                    helperText={errors.dtNascimento ? errors.dtNascimento : ''}
                    as={KeyboardDatePicker}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Field
                    name="deRg"
                    label="RG*"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                    fullWidth
                    error={!!errors.deRg}
                    helperText={errors.deRg ? errors.deRg : ''}
                    as={TextField}
                    inputProps={{
                        maxLength: 10,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <Field
                    name="dtRg"
                    label="Data de expedição*"
                    format="DD/MM/YYYY"
                    autoOk
                    clearable
                    clearLabel={'Limpar'}
                    emptyLabel={''}
                    value={helpers.formatarData(values.dtRg)}
                    invalidLabel="Data inválida"
                    invalidDateMessage="Data inválida"
                    maxDateMessage="Data inválida"
                    minDateMessage="Data inválida"
                    margin="dense"
                    disabled={!canEdit}
                    onChange={(v) => onChangeDate(values, 'dtRg', v)}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    inputVariant="filled"
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                    error={!!errors.dtRg}
                    helperText={errors.dtRg ? errors.dtRg : ''}
                    as={KeyboardDatePicker}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <Field
                    name="sgOrgaoRg"
                    label="Órgão expedidor*"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                    fullWidth
                    error={!!errors.sgOrgaoRg}
                    helperText={errors.sgOrgaoRg ? errors.sgOrgaoRg : ''}
                    as={TextField}
                    inputProps={{
                        maxLength: 130,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={2}>
                <FormControl
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                    fullWidth
                    error={!!errors.sgUfRg}>
                    <InputLabel htmlFor="uf" shrink={!!values.sgUfRg}>
                        UF*
                    </InputLabel>
                    <Field name="sgUfRg" id="sgUfRg" native as={Select}>
                        <option value=""></option>
                        <option value="AC">AC</option>
                        <option value="AL">AL</option>
                        <option value="AM">AM</option>
                        <option value="AP">AP</option>
                        <option value="BA">BA</option>
                        <option value="CE">CE</option>
                        <option value="DF">DF</option>
                        <option value="ES">ES</option>
                        <option value="GO">GO</option>
                        <option value="MA">MA</option>
                        <option value="MG">MG</option>
                        <option value="MS">MS</option>
                        <option value="MT">MT</option>
                        <option value="PA">PA</option>
                        <option value="PB">PB</option>
                        <option value="PE">PE</option>
                        <option value="PI">PI</option>
                        <option value="PR">PR</option>
                        <option value="RJ">RJ</option>
                        <option value="RN">RN</option>
                        <option value="RO">RO</option>
                        <option value="RR">RR</option>
                        <option value="RS">RS</option>
                        <option value="SC">SC</option>
                        <option value="SE">SE</option>
                        <option value="SP">SP</option>
                        <option value="TO">TO</option>
                    </Field>
                    {errors.sgUfRg ? <FormHelperText>{errors.sgUfRg}</FormHelperText> : null}
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
                <Field
                    name="deCnh"
                    label="CNH*"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                    fullWidth
                    error={!!errors.deCnh}
                    helperText={errors.deCnh ? errors.deCnh : ''}
                    as={TextField}
                    inputProps={{
                        maxLength: 11,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <Field
                    name="dtValidadeCnh"
                    label="Data de validade*"
                    format="DD/MM/YYYY"
                    autoOk
                    clearable
                    clearLabel={'Limpar'}
                    emptyLabel={''}
                    value={helpers.formatarData(values.dtValidadeCnh)}
                    invalidLabel="Data inválida"
                    invalidDateMessage="Data inválida"
                    maxDateMessage="Data inválida"
                    minDateMessage="Data inválida"
                    margin="dense"
                    disabled={!canEdit}
                    onChange={(v) => onChangeDate(values, 'dtValidadeCnh', v)}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    inputVariant="filled"
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                    error={!!errors.dtValidadeCnh}
                    helperText={errors.dtValidadeCnh ? errors.dtValidadeCnh : ''}
                    as={KeyboardDatePicker}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <FormControl
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                    fullWidth
                    error={!!errors.tpCategoriaCnh}>
                    <InputLabel htmlFor="uf" shrink={!!values.tpCategoriaCnh}>
                        Categoria CNH*
                    </InputLabel>
                    <Field name="tpCategoriaCnh" id="tpCategoriaCnh" native as={Select}>
                        <option value=""></option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="AB">AB</option>
                        <option value="C">C</option>
                        <option value="AC">AC</option>
                        <option value="D">D</option>
                        <option value="AD">AD</option>
                        <option value="E">E</option>
                        <option value="AE">AE</option>
                    </Field>
                    {errors.tpCategoriaCnh ? <FormHelperText>{errors.tpCategoriaCnh}</FormHelperText> : null}
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
                <FormControl
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                    fullWidth
                    error={!!errors.sgUfCnh}>
                    <InputLabel htmlFor="uf" shrink={!!values.sgUfCnh}>
                        UF*
                    </InputLabel>
                    <Field name="sgUfCnh" id="sgUfCnh" native as={Select}>
                        <option value=""></option>
                        <option value="AC">AC</option>
                        <option value="AL">AL</option>
                        <option value="AM">AM</option>
                        <option value="AP">AP</option>
                        <option value="BA">BA</option>
                        <option value="CE">CE</option>
                        <option value="DF">DF</option>
                        <option value="ES">ES</option>
                        <option value="GO">GO</option>
                        <option value="MA">MA</option>
                        <option value="MG">MG</option>
                        <option value="MS">MS</option>
                        <option value="MT">MT</option>
                        <option value="PA">PA</option>
                        <option value="PB">PB</option>
                        <option value="PE">PE</option>
                        <option value="PI">PI</option>
                        <option value="PR">PR</option>
                        <option value="RJ">RJ</option>
                        <option value="RN">RN</option>
                        <option value="RO">RO</option>
                        <option value="RR">RR</option>
                        <option value="RS">RS</option>
                        <option value="SC">SC</option>
                        <option value="SE">SE</option>
                        <option value="SP">SP</option>
                        <option value="TO">TO</option>
                    </Field>
                    {errors.sgUfCnh ? <FormHelperText>{errors.sgUfCnh}</FormHelperText> : null}
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
                <Field
                    name="deFiliacaoPai"
                    label="Nome do Pai*"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                    fullWidth
                    error={!!errors.deFiliacaoPai}
                    helperText={errors.deFiliacaoPai ? errors.deFiliacaoPai : ''}
                    as={TextField}
                    inputProps={{
                        maxLength: 130,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Field
                    name="deFiliacaoMae"
                    label="Nome da Mãe*"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                    fullWidth
                    error={!!errors.deFiliacaoMae}
                    helperText={errors.deFiliacaoMae ? errors.deFiliacaoMae : ''}
                    as={TextField}
                    inputProps={{
                        maxLength: 130,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Field
                    name="nuInss"
                    label="Número de Registro no INSS*"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                    fullWidth
                    error={!!errors.nuInss}
                    helperText={errors.nuInss ? errors.nuInss : ''}
                    as={TextField}
                    inputProps={{
                        maxLength: 10,
                    }}
                />
            </Grid>

            <Grid item xs={12}>
                <Field
                    name="deObservacao"
                    label="Observações"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit}
                    multiline
                    minRows={4}
                    fullWidth
                    as={TextField}
                    inputProps={{
                        maxLength: 4900,
                    }}
                />
            </Grid>
        </Grid>
    );
}

export default MainData;
